<template>
  <span class="val-wrap">
<!--    <span class="val-text">{{ arrow }}{{ val }}</span>-->
    <span class="val-text"> {{ val }}</span>
    <b-tag v-if="unit" type="" size="is-small" class="ml-1"><small>{{ unit }}</small></b-tag>
    <b-tag v-if="ref"  type="" size="is-small" class="ml-1"><small>{{ ref }}</small> </b-tag>
    <b-tag v-if="flag"  type="" size="is-small" class="ml-1"><small>{{ flag }}</small></b-tag>
  </span>
</template>

<script>
export default {
  name: "ValueWithTagsRenderer",
  // ag-Grid จะส่ง prop 'params' เข้ามาอัตโนมัติ
  props: {
    // params: { type: Object, required: true }
  },
  computed: {
    payload() {
      // เราคาดหวังว่า parent จะส่งฟังก์ชัน getPayload มาใน cellRendererParams
      try {
        const fn = this.params && this.params.getPayload;
        return typeof fn === 'function' ? fn(this.params) : null;
      } catch (e) {
        return null;
      }
    },
    val() {
      return this.payload && this.payload.val != null ? String(this.payload.val) : "";
    },
    flag() {
      return (this.payload && this.payload.flag || "").toString().trim().toUpperCase();
    },
    arrow() {
      return this.flag === "H" ? "↑ " : this.flag === "L" ? "↓ " : "";
    },
    unit() {
      return this.payload && this.payload.unitName ? this.payload.unitName : "";
    },
    ref() {
      return this.payload && this.payload.refVal ? this.payload.refVal : "";
    }
  }
};
</script>

<style scoped>
.val-wrap { display: inline-flex; align-items: center; gap: 6px; }
.val-text { line-height: 1.2; }
.ml-1 { margin-left: 6px; }
</style>
